/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { KundenstatuslisteRetrieveResponse } from '../models/kundenstatusliste-retrieve-response';
import { KundenstatuslisteRetrieveRequest } from '../models/kundenstatusliste-retrieve-request';
@Injectable({
  providedIn: 'root',
})
class KundenstatuslisteService extends __BaseService {
  static readonly kundenstatuslisteRetrieveCreatePath = '/kundenstatusliste/retrieve';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  kundenstatuslisteRetrieveCreateResponse(data: KundenstatuslisteRetrieveRequest): __Observable<__StrictHttpResponse<Array<KundenstatuslisteRetrieveResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/kundenstatusliste/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<KundenstatuslisteRetrieveResponse>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  kundenstatuslisteRetrieveCreate(data: KundenstatuslisteRetrieveRequest): __Observable<Array<KundenstatuslisteRetrieveResponse>> {
    return this.kundenstatuslisteRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as Array<KundenstatuslisteRetrieveResponse>)
    );
  }
}

module KundenstatuslisteService {
}

export { KundenstatuslisteService }
